<!--
 * @Description: 
 * @Author: lixiaoli
 * @Date: 2022-12-09 16:01:55
 * @LastEditors: lixiaoli
 * @LastEditTime: 2024-09-12 17:36:00
 * @FilePath: \visualization-platform-jiangsu\src\App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { mapActions } from "vuex"
export default {
  name: 'app',
  data(){
    return{}
  },
  created () {
  },
  mounted() {
    // if (this._isMobile()) {
    //   // 手机端
    //   this.$router.replace("/mobile/login");
    // } else {
      // pc端
      // this.$router.replace("/Login");
      function checkIE(){
        return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
      }
      if (checkIE()) {
        window.addEventListener('hashchange', () => {
          var currentPath = window.location.hash.slice(1);
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        }, false)
      }
    // }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows phone)/i
      );
      return flag;
    }
  }
}
</script>

<style>
#app,body,html{
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  /*-webkit-font-smoothing: antialiased;*/
  /*-moz-osx-font-smoothing: grayscale;*/
  /*text-align: center;*/
  /*color: #2c3e50;*/
  /*margin:0;*/
  /*padding: 0;*/
  /*height:100%;*/
  width: 100%;
  height: 100%; 
}

</style>



// WEBPACK FOOTER //
// src/App.vue